import { call } from 'redux-saga/effects';
import { FBUY_QUERY_PARAM } from 'redux/saga/selectors/friendbuy';
import { memberHasStatus } from 'redux/saga/helpers/member';

export const homepageOnEnter = function* homepageOnEnter(client, nextState, replaceState) {
  // If a user has a FriendBuy shortlink that redirects to a our homepage due to local caching,
  // we want to redirect them to the our dedicated referral page
  const fbuyQueryParamVal = nextState.location.query[FBUY_QUERY_PARAM];
  if (fbuyQueryParamVal) {
    // When the FBUY_QUERY_PARAM gets serialized via 3rd party lib & val stored as cookie,
    // it automatically removes the query param from the url, here we add it back into url
    return yield call(replaceState, `/referral?${FBUY_QUERY_PARAM}=${fbuyQueryParamVal}`);
  }

  if (yield call(memberHasStatus, client, 'CANCELLED')) {
    yield call(replaceState, '/rejoin');
  }
};
